import { render, staticRenderFns } from "./phone-number.vue?vue&type=template&id=71aac0ff&scoped=true&"
var script = {}
import style0 from "./phone-number.vue?vue&type=style&index=0&id=71aac0ff&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71aac0ff",
  null
  
)

export default component.exports